import { call, put, select, takeLatest } from "redux-saga/effects";
import { v4 as uuid } from "uuid";

import constants from "../../assets/constants";
import { GetKPIsByPillar } from "../../assets/empireData";
import * as OmniDataAPI from "../../data/omniDataAPI";
import { createNewInvite } from "../../data/omniDataModel";
import * as AdminSessionActions from "../../state/redux/adminSession";
import * as BotpresssSessionActions from "../../state/redux/botpressSession";
import * as CreationActions from "../../state/redux/creatorSession";
import * as PartnerSessionActions from "../../state/redux/partnerSession";
import * as PatientSessionActions from "../../state/redux/patientSession";
import * as ProviderSessionActions from "../../state/redux/providerSession";
import { isValidUUID } from "../../utils/helpers";
import * as UserSessionStorage from "../../utils/userSessionStorage";
import * as Actions from "../redux/userSession";

export function* setTheme({ payload }) {
  try {
    let themeId = payload;
    if (typeof themeId == "string" || themeId instanceof String) {
      themeId = parseInt(themeId);
    }

    yield call(UserSessionStorage.storeCurrentTheme, payload);
    yield put(Actions.setThemeSuccess(payload));
  } catch (error) {
    yield put(Actions.userSessionRequestFailed());
  }
}

export function* setAwsUser({ payload }) {
  try {
    yield put(Actions.setAwsUserSuccess(payload));

    let groups =
      payload.signInUserSession.accessToken.payload["cognito:groups"] != null
        ? payload.signInUserSession.accessToken.payload["cognito:groups"]
        : [];

    if (groups.length > 0) {
      yield put(Actions.setAwsGroupRequest(groups[0]));
    }
  } catch (error) {
    yield put(Actions.userSessionRequestFailed());
  }
}

export function* setAwsGroup({ payload }) {
  try {
    yield put(Actions.setAwsGroupSuccess(payload));
  } catch (error) {
    yield put(Actions.userSessionRequestFailed());
  }
}

export function* setBpShowChat({ payload }) {
  try {
    yield put(Actions.setBpShowChatSuccess(payload));
  } catch (error) {
    yield put(Actions.userSessionRequestFailed());
  }
}

export function* setShowSettings({ payload }) {
  try {
    yield put(Actions.setShowSettingsSuccess(payload));
  } catch (error) {
    yield put(Actions.userSessionRequestFailed());
  }
}

export function* loadUserODM({ payload }) {
  try {
    //clear out the existing information
    yield put(Actions.setUserODMRequest(null));
    if (isValidUUID(payload)) {
      //payload is a valid UUID
      let userODM = null;

      const groupSelector = yield select(Actions.awsGroupSelector);

      if (groupSelector === constants.userGroups.Administrator) {
        userODM = yield call(OmniDataAPI.getAdministrator, payload);
      } else if (groupSelector === constants.userGroups.Provider) {
        userODM = yield call(OmniDataAPI.getProvider, payload);
      } else if (groupSelector === constants.userGroups.Partner) {
        userODM = yield call(OmniDataAPI.getPartner, payload);
      } else if (groupSelector === constants.userGroups.Patient) {
        userODM = yield call(OmniDataAPI.getPatient, payload);
      } else {
        yield put(
          Actions.userSessionRequestFailed("OmniDataAPI.loadUserODM FAILED, no valid group"),
        );
      }

      if (userODM == null) {
        yield put(Actions.userSessionRequestFailed("OmniDataAPI.loadUserODM FAILED"));
      } else {
        //make Anccilary Load Calls.
        if (groupSelector === constants.userGroups.Administrator) {
          yield put(AdminSessionActions.setAdministratorODMRequest(userODM));
        } else if (groupSelector === constants.userGroups.Provider) {
          yield put(ProviderSessionActions.setProviderODMRequest(userODM));
        } else if (groupSelector === constants.userGroups.Partner) {
          yield put(PartnerSessionActions.setPartnerODMRequest(userODM));
        } else if (groupSelector === constants.userGroups.Patient) {
          yield put(PatientSessionActions.setPatientODMRequest(userODM));
        } else {
          yield put(
            Actions.userSessionRequestFailed("OmniDataAPI.loadUserODM FAILED, no valid group"),
          );
        }

        yield put(Actions.setUserODMRequest(userODM));
        yield put(Actions.loadUserODMSuccess());
      }
    } else {
      yield put(Actions.userSessionRequestFailed("OmniDataAPI.loadUserODM invalid UUID"));
    }
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

export function* setUserODM({ payload }) {
  try {
    //Validate Object

    yield put(Actions.setBPClientIdRequest("ce635d54-d891-49b4-b2da-9150712cc43d"));

    if (payload != null) {
      yield put(Actions.loadOrganizationODMRequest(payload.omniAudit.organizationId));

      //generate the Users KPIs
      let userKPIs = GetKPIsByPillar(payload.omniData.businessPillar);

      yield put(Actions.setUserKPIsRequest(userKPIs));
    }

    yield put(Actions.setUserODMSuccess(payload));
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

export function* loadUserToDos({ payload }) {
  try {
    //most of this should be moved to lookup calls in the DB eventually

    const userODM = yield select(Actions.userODMSelector);
    const organizationODM = yield select(Actions.organizationODMSelector);
    // Let's grab some ToDos
    if (userODM != null && organizationODM != null) {
      let theReturn = [];
      if (organizationODM.omniData.organizationType === constants.organizationTypeEnums.empireOS) {
        theReturn = constants.empireUserToDos.filter(toDo => {
          return (
            toDo.businessPillar === "all" || toDo.businessPillar === userODM.omniData.businessPillar
          );
        });

        // constants.empireUserToDos.forEach(kpi => {
        //   theReturn.push(kpi);
        // });
      } else if (
        organizationODM.omniData.organizationType === constants.organizationTypeEnums.nsight
      ) {
        theReturn = constants.nsightUserToDos;
      } else {
        theReturn.push(constants.userToDos.find(toDo => toDo.toDoType === "profileCompletion"));
        theReturn.push(constants.userToDos.find(toDo => toDo.toDoType === "openInvitation"));
        theReturn.push(constants.userToDos.find(toDo => toDo.toDoType === "takeAnotherAssessment"));
      }
      // We need to load some default ToDose
      // 1. profileCompletion
      // 2. openInvitation
      // 3. takeAnotherAssessment
      // Update the keys this could be anything
      // other than uuid if we want
      theReturn.map(toDo => {
        toDo.id = uuid();
        toDo.key = `${toDo.toDoType}-${uuid()}`;
        return toDo;
      });
      yield put(Actions.loadUserToDosSuccess(theReturn));
    }
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}
export function* updateUserToDos({ payload }) {
  try {
    yield put(Actions.updateUserToDosSuccess(payload));
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

export function* reflectUpdatedUserODM({ payload }) {
  try {
    const userODM = yield select(Actions.userODMSelector);

    if (payload != null && userODM != null && payload._id === userODM._id) {
      //we editied our ODM
      yield put(Actions.setUserODMRequest(payload));
      yield put(Actions.reflectUpdatedUserODMSuccess());
    }
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

export function* setOrganizationODM({ payload }) {
  try {
    //Validate Object
    if (payload != null) {
      yield put(Actions.setThemeRequest(payload.omniData.themeId));

      //check the invites
      if (!payload.omniData.sharedInviteKey) {
        let permInvite = createNewInvite(
          payload.omniData.organizationType === constants.organizationTypeEnums.empireOS
            ? constants.onboardingUserType.provider
            : constants.onboardingUserType.partner,
        );

        //unprocessable content huh?
        permInvite.omniData.userData.email = "coach@omnisciahealth.com";
        permInvite.omniData.userData.mobilePhone = "(111)111-1111";
        permInvite.omniData.userData.familyName = "Health";
        permInvite.omniData.userData.givenName = "Omniscia";
        permInvite.omniData.userData.displayName = "Omniscia Health";

        permInvite.omniData.inviteType = constants.inviteType.shared;
        permInvite.omniData.target = `Public Shared Invitation`;

        let newInvite = yield call(OmniDataAPI.createInvite, permInvite);

        if (newInvite != null) {
          // relatedInvites.push(newInvite);
          //update the organization
          payload.omniData.sharedInviteKey = newInvite.omniData.inviteKey;
          //save the org

          yield put(CreationActions.updateOrganizationRequest(payload));
        }
      }

      if (payload.omniData.botpressBots != null && payload.omniData.botpressBots.length > 0) {
        //the test bot is the first bot that is not "production" or "analytics"
        let botIndex = 0;
        botIndex = payload.omniData.botpressBots.findIndex(item => item.omniData.isProduction);
        if (botIndex < 0) {
          botIndex = payload.omniData.botpressBots.findIndex(
            item => !item.omniData.isConversationAnalytics,
          );
        }
        if (botIndex < 0) {
          botIndex = 0;
        }

        yield put(
          BotpresssSessionActions.setBotpressBotODMRequest(payload.omniData.botpressBots[botIndex]),
        );
        botIndex = payload.omniData.botpressBots.findIndex(
          item => item.omniData.isConversationAnalytics,
        );
        if (botIndex >= 0) {
          yield put(
            BotpresssSessionActions.setAnalyticsBotODMRequest(
              payload.omniData.botpressBots[botIndex],
            ),
          );
        }

        //the test bot is the first bot that is not "production" or "analytics"
        botIndex = payload.omniData.botpressBots.findIndex(
          item => !item.omniData.isProduction && !item.omniData.isConversationAnalytics,
        );
        if (botIndex < 0) {
          botIndex = 0;
        }
        yield put(
          BotpresssSessionActions.setTestBotODMRequest(payload.omniData.botpressBots[botIndex]),
        );
      }
    } else {
      yield put(BotpresssSessionActions.setBotpressBotODMRequest(null));
    }

    yield put(Actions.setOrganizationODMSuccess(payload));
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

export function* loadOrganizationODM({ payload }) {
  try {
    //clear out the existing information
    yield put(Actions.setOrganizationODMRequest(null));
    if (isValidUUID(payload)) {
      //payload is a valid UUID
      let orgODM = yield call(OmniDataAPI.getOrganization, payload);

      if (orgODM == null) {
        yield put(Actions.userSessionRequestFailed("OmniDataAPI.loadOrganizationODM FAILED"));
      } else {
        yield put(Actions.setOrganizationODMRequest(orgODM));
        yield put(Actions.loadOrganizationODMSuccess());
      }
    } else {
      yield put(Actions.userSessionRequestFailed("OmniDataAPI.loadOrganizationODM invalid UUID"));
    }
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

export function* reflectUpdatedOrganizationODM({ payload }) {
  try {
    const organizationODM = yield select(Actions.organizationODMSelector);

    if (payload != null && organizationODM != null && payload._id === organizationODM._id) {
      //we editied our ODM
      yield put(Actions.setThemeRequest(payload.omniData.themeId));
      yield put(Actions.reflectUpdatedOrganizationODMSuccess(payload));
    }
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

export function* setProxyPatientODM({ payload }) {
  try {
    //Validate Object if you want
    if (payload != null) {
      yield put(Actions.loadUserAssessmentsRequest(payload._id));
    }

    yield put(Actions.setProxyPatientODMSuccess(payload));
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

export function* setBPClientId({ payload }) {
  try {
    yield put(Actions.setBPClientIdSuccess(payload));
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

export function* setUserAssessments({ payload }) {
  try {
    yield put(Actions.setUserAssessmentsSuccess(payload));
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

export function* loadUserAssessments({ payload }) {
  try {
    if (isValidUUID(payload)) {
      //payload is a valid UUID

      let assessments = yield call(OmniDataAPI.getAllAssessmentByRelatedID, payload);

      yield put(Actions.loadUserAssessmentsSuccess());
      yield put(Actions.setUserAssessmentsRequest(assessments));
    } else {
      yield put(Actions.userSessionRequestFailed("loadUserAssessments: Invalid UUID"));
      yield put(Actions.setUserAssessmentsRequest(null));
    }
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

export function* setUserKPIs({ payload }) {
  try {
    yield put(Actions.setUserKPIsSuccess(payload));
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

export function* updateUserKPI({ payload }) {
  try {
    const currentList = yield select(Actions.userKPIsSelector);

    const newList = currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id); //creates a copy of the list

    if (payload._id == null) {
      payload.id = uuid();
    }
    newList.push(payload);

    yield put(Actions.setUserKPIsSuccess(newList));
  } catch (error) {
    yield put(Actions.userSessionRequestFailed(error));
  }
}

//  saga
export default function* userSessionSaga() {
  yield takeLatest(Actions.setThemeRequest, setTheme);
  yield takeLatest(Actions.setAwsUserRequest, setAwsUser);
  yield takeLatest(Actions.setAwsGroupRequest, setAwsGroup);

  yield takeLatest(Actions.setShowSettingsRequest, setShowSettings);

  yield takeLatest(Actions.loadUserODMRequest, loadUserODM);
  yield takeLatest(Actions.setUserODMRequest, setUserODM);
  yield takeLatest(Actions.loadUserToDosRequest, loadUserToDos);
  yield takeLatest(Actions.updateUserToDosRequest, updateUserToDos);
  yield takeLatest(Actions.reflectUpdatedUserODMRequest, reflectUpdatedUserODM);

  yield takeLatest(Actions.setBpShowChatRequest, setBpShowChat);

  yield takeLatest(Actions.loadOrganizationODMRequest, loadOrganizationODM);
  yield takeLatest(Actions.setOrganizationODMRequest, setOrganizationODM);
  yield takeLatest(Actions.reflectUpdatedOrganizationODMRequest, reflectUpdatedOrganizationODM);

  yield takeLatest(Actions.setProxyPatientODMRequest, setProxyPatientODM);
  yield takeLatest(Actions.setBPClientIdRequest, setBPClientId);
  yield takeLatest(Actions.setUserAssessmentsRequest, setUserAssessments);
  yield takeLatest(Actions.loadUserAssessmentsRequest, loadUserAssessments);
  yield takeLatest(Actions.setUserKPIsRequest, setUserKPIs);
  yield takeLatest(Actions.updateUserKPIRequest, updateUserKPI);
}
